/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useState} from 'react'
import i18next from 'i18next'
import {useTranslation} from 'react-i18next'
import swal from 'sweetalert'
import { Button, Form, Modal, Spinner } from 'react-bootstrap'
import { KTSVG } from 'src/_metronic/helpers'
import { importData } from 'src/api/modules/configuration/approval'
import { InputFile } from 'src/app/components/InputFile'

interface Props {
  onDataImported: () => void;
}

export const ButtonImport:FC<Props> = ({ onDataImported }) => {
  const {t} = useTranslation()

  const [loading, setLoading] = useState(false)
  const [show, setShow] = useState(false)
  const [files, setFiles] = useState({file: null})

  const handleUpload = async () => {
    setLoading(true)
    const lang = i18next.language
    let file = files.file
    let formdata = new FormData()
    formdata.append('file', file!)

    await importData(formdata, lang)
      .then((res: any) => {
        swal({
          title: `${t('document uploaded successfully')}`,
          icon: 'success',
        }).then(() => {
          const inputfile = document.getElementById('upload') as HTMLInputElement
          inputfile!.value = ''
          setShow(false)
          onDataImported()
        })
      })
      .catch((err: any) => {
        swal({
          title: t(err.response.data.message),
          icon: 'error',
        })
      })
    setLoading(false)
  }

  return (
    <>
      <button
        onClick={() => {
          setShow(true)
        }}
        className='btn btn-warning me-2'
        title={t('Import')}
      >
        <KTSVG path='/media/icons/duotune/cloud-arrow-up-fill.svg' />
        {t('Import')}
      </button>

      <Modal
        show={show}
        onHide={() => setShow(false)}
        backdrop='static'
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('Import')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <table>
            <tr>
              <td style={{width: '120px'}}>
                <h6>{t('order-fileUnggah')}</h6>
              </td>
              <td className='w-75'>
                <InputFile
                    setFileName={(_: string) => {}}
                    setFiles={setFiles}
                    isBase64={false}
                />
              </td>
            </tr>
          </table>
          <div className='d-flex justify-content-end mt-5'>
            <Button
              variant='primary'
              className='w-100 '
              onClick={() => handleUpload()}
              disabled={loading}
            >
              {loading ? (<Spinner animation='border' variant='light' size='sm' />) : (t('order-kirim'))}
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}
